/**
 * Redirect URL utilities with locale support
 *
 * US (hillsvet.com): no window.fsl_locale → /food-shelter-love
 * CA (hillsvet.ca): window.fsl_locale = 'en-ca' | 'fr-ca' → /{locale}/food-shelter-love
 */

type Environment = 'aem' | 'standalone' | 'local';

const getLocale = (): string | null => {
  if (!window.fsl_locale) return null;
  return window.fsl_locale.toLowerCase();
};

const getEnvironment = (): Environment => {
  const host = window.location.hostname;
  if (host.includes('hillsvet.com') || host.includes('hillsvet.ca')) return 'aem';
  if (host.includes('fsl-frontend.hillsvet.com')) return 'standalone';
  return 'local';
};

const buildUrl = (target: string, includeOrigin: boolean): string => {
  const env = getEnvironment();
  const locale = getLocale();

  let path = `/${target}`;

  // Only prefix when AEM sets window.fsl_locale (CA); US leaves it unset
  if ((env === 'aem' || env === 'local') && target === 'food-shelter-love' && locale) {
    path = `/${locale}/${target}`;
  }

  return includeOrigin ? `${window.location.origin}${path}` : path;
};

export const getFoodShelterLoveRedirectUrl = (): string => buildUrl('food-shelter-love', true);
